import { Component, HostListener, Input, OnDestroy } from "@angular/core";
import { SafePipe } from "@app/shared/pipe/safe.pipe";
import { EnvService } from "@envs/env-service";
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import _ from "lodash";
import { AuthService } from '@core/service/auth.service'
import { environment } from '@envs/environment';
import { Store } from "@ngrx/store";
import { CompanyManagementActions } from "../../store/actions/company-management.actions";

@Component({
  selector: 'group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
  providers: [ SafePipe ],

})
export class GroupComponent implements OnDestroy {
  @Input() id!: number;
  @Input() isSettings: boolean;
  baseJsUrl: string

  constructor(private envService: EnvService, private router: Router, private store$: Store,
              private route: ActivatedRoute, private titleService: Title, private authService: AuthService) {}

  ngOnInit() {
    this.baseJsUrl = `${this.envService.baseJsUrl}/admin?tab=groups&host=${environment.baseHost}&childCompany=${this.authService.loggedInUser?.company.id}&group=${this.id}&isSettings=${!!this.isSettings}`
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data.action === 'adminNavigate') {
      this.store$.dispatch(CompanyManagementActions.setGroupId({groupId: undefined}))
      this.titleService.setTitle(_.startCase(_.camelCase(event.data.location)) + ' | Admin | Scope')
      this.router.navigate(
        [`/manage`],
        {
          queryParams: { 'tab': event.data.location }
        }
      )
    }
  }

  ngOnDestroy() {
    this.store$.dispatch(CompanyManagementActions.setGroupId({groupId: undefined}))
  }
}
